import React, { useState } from 'react';
import './ProjectsPage.css';
import KrishnaVatikaModal    from '../components/KrishnaVatikaModal/KrishnaVatikaModal';
import LotusGreensModal      from '../components/LotusGreensModal/LotusGreensModal';
import SrishtiModal          from '../components/SrishtiModal/SrishtiModal';
import BollywoodFarmsModal   from '../components/BollywoodFarmsModal/BollywoodFarmsModal';
import GreenPlazaModal       from '../components/GreenPlazaModal/GreenPlazaModal';

const projects = [
  {
    id: 'krishnavatika',
    name: 'Krishna Vatika',
    type: '4 BHK Premium Villas',
    location: 'Sector 16-B, Greater Noida West',
    price: 'Starting ₹57 Lac*',
    image: '/image/krishna-vatika.webp',
    badge: 'RERA Approved',
    badgeColor: '#7B2D8B',
    tags: ['4 BHK', 'Gated Community', '2100–2550 sq.ft'],
    hot: false,
    action: 'modal',
  },
  {
    id: 'lotusgreens',
    name: 'Lotus Greens Villa 2',
    type: '3 & 4 BHK Smart Villas',
    location: 'Vaidpura, Greater Noida West',
    price: 'Starting ₹65 Lac*',
    image: '/image/loutusgreenvilla.png',
    badge: 'Vastu Compliant',
    badgeColor: '#1B6B2E',
    tags: ['3 & 4 BHK', '25ft Wide Roads', '100–116 Sq.Yd.'],
    hot: true,
    action: 'modal',
  },
  {
    id: 'srishti',
    name: 'Aalayam Srishti Villas',
    type: '2 & 3 BHK Premium Villas',
    location: 'Sec 16, Chipyana Bujurg, Greater Noida West',
    price: 'Starting ₹45 Lac*',
    image: '/image/ShrishtiHeights.webp',
    badge: 'Ready to Move',
    badgeColor: '#C0176B',
    tags: ['2 & 3 BHK', 'Commercial Club', '72–100 Sq.Yd.'],
    hot: false,
    action: 'modal',
  },
  {
    id: 'bollywoodfarms',
    name: 'Bollywood Aero City Farms',
    type: 'Luxury Farm Estates',
    location: 'Village Sarakpur, Near Jewar Airport, Yamuna Expressway',
    price: '₹20,000 / Sq.Yd.',
    image: '/image/bollywoodaerocity.jpeg',
    badge: 'High ROI Investment',
    badgeColor: '#8B6914',
    tags: ['Farm Estate', '1000 Sq.Yd. Min.', 'Near Jewar Airport'],
    hot: true,
    action: 'modal',
  },
  {
    id: 'greenplaza',
    name: 'Paradise Greens Plaza',
    type: 'Studio Apartments & Retail Shops',
    location: 'Sector 16B, Near 1 Murti Chowk, Noida Extension',
    price: 'Starting ₹23.09 Lac*',
    image: '/image/Greenparadise.jpg',
    badge: 'Ready to Move',
    badgeColor: '#0D1B3E',
    tags: ['Studio Apt', 'Retail Shops', 'Assured Rental'],
    hot: false,
    action: 'modal',
  },
  {
    id: 'brochure-gv',
    name: 'Brochure GV',
    type: 'Krishna Vatika — Official Brochure',
    location: 'Sector 16-B, Greater Noida West',
    price: 'Download Brochure',
    image: '/image/GV1.jpg',
    badge: 'Official Brochure',
    badgeColor: '#9B1B30',
    tags: ['4 BHK Villas', 'Floor Plans', 'Site Map'],
    hot: false,
    action: 'pdf',
    pdf: '/brochure/GV.pdf',
  },
];

export default function ProjectsPage() {
  const [openModal, setOpenModal] = useState(null);

  const handleCardClick = (p) => {
    if (p.action === 'pdf') {
      window.open(p.pdf, '_blank');
    } else {
      setOpenModal(p.id);
    }
  };

  return (
    <div className="pp-page">

      {/* Hero Banner */}
      <div className="pp-hero">
        <div className="pp-hero-overlay" />
        <div className="pp-hero-content">
          <span className="pp-eyebrow">Our Projects</span>
          <h1>Premium Properties in<br /><span>Greater Noida West</span></h1>
          <p>Explore our curated portfolio of RERA-approved residential & commercial projects</p>
        </div>
      </div>

      {/* Projects Grid */}
      <div className="pp-container">
        <div className="pp-grid">
          {projects.map(p => (
            <div
              key={p.id}
              className={`pp-card ${p.action === 'pdf' ? 'pp-card-brochure' : ''}`}
              onClick={() => handleCardClick(p)}
            >
              <div className="pp-card-img">
                <img src={p.image} alt={p.name} />
                <div className="pp-card-overlay" />
                {p.hot && <span className="pp-hot-badge">🔥 Hot</span>}
                <span className="pp-status-badge" style={{ background: p.badgeColor }}>
                  {p.badge}
                </span>

                {/* PDF card gets a special download hint */}
                {p.action === 'pdf' ? (
                  <div className="pp-view-hint pdf-hint">
                    <i className="fa fa-file-pdf" /> View Brochure PDF
                  </div>
                ) : (
                  <div className="pp-view-hint">
                    <i className="fa fa-eye" /> View Details
                  </div>
                )}

                {/* PDF icon overlay on brochure card */}
                {p.action === 'pdf' && (
                  <div className="pp-pdf-icon">
                    <i className="fa fa-file-pdf" />
                  </div>
                )}
              </div>

              <div className="pp-card-body">
                <div className="pp-card-type">{p.type}</div>
                <h3>{p.name}</h3>
                <div className="pp-card-location">
                  <i className="fa fa-location-dot" /> {p.location}
                </div>
                <div className="pp-card-tags">
                  {p.tags.map(t => <span key={t}>{t}</span>)}
                </div>
                <div className="pp-card-footer">
                  <div className={`pp-price ${p.action === 'pdf' ? 'pp-price-dl' : ''}`}>
                    {p.action === 'pdf' && <i className="fa fa-download" />} {p.price}
                  </div>
                  <button
                    className={`pp-details-btn ${p.action === 'pdf' ? 'pp-btn-red' : ''}`}
                  >
                    {p.action === 'pdf' ? (
                      <><i className="fa fa-file-pdf" /> View PDF</>
                    ) : (
                      <>View Details <i className="fa fa-arrow-right" /></>
                    )}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Brochure note */}
        <div className="pp-brochure-note">
          <i className="fa fa-info-circle" />
          <span>
            Click on <strong>Brochure GV</strong> to view the official Krishna Vatika PDF brochure.
            Place your PDF at <code>public/brochure/GV.pdf</code> to enable download.
          </span>
        </div>
      </div>

      {/* Modals */}
      {openModal === 'krishnavatika'  && <KrishnaVatikaModal  onClose={() => setOpenModal(null)} />}
      {openModal === 'lotusgreens'    && <LotusGreensModal    onClose={() => setOpenModal(null)} />}
      {openModal === 'srishti'        && <SrishtiModal        onClose={() => setOpenModal(null)} />}
      {openModal === 'bollywoodfarms' && <BollywoodFarmsModal onClose={() => setOpenModal(null)} />}
      {openModal === 'greenplaza'     && <GreenPlazaModal     onClose={() => setOpenModal(null)} />}
    </div>
  );
}
